import React,{useState} from 'react';
import { connect } from "react-redux";
import CheckoutItem from "../../components/checkout-item/checkout-item.component";
import { createStructuredSelector } from "reselect";
import { selectCartItems,selectCartTotal } from "../../redux/cart/cart.selectors";
import './checkout.styles.scss';
import CustomButton from '../../components/custom-button/custom-button.component'
import CashOnDelivery from '../../components/cashondelivery/cashondelivery.component'
import PayPalCheckout from "../../components/stripe-button/stripe-button.component";
const CheckoutPage = ({cartItems,total}) => {
  const [view,setView] = useState({viewForm:false})
  const {viewForm} = view
  let tota = Number.parseFloat(total).toPrecision(4);
  return(  
        <div>
        <div className="checkout-page">
        <div className="checkout-header">
            <div className="header-block">
                <span>Product</span>
            </div>
            <div className="header-block">
                <span>Description</span>
            </div>
            <div className="header-block">
                <span>Quantity</span>
            </div>
            <div className="header-block">
                <span>Price</span>
            </div>
            <div className="header-block">
                <span>Remove</span>
            </div>
        </div>
        {
            cartItems.map(cartItem => 
                <CheckoutItem key={cartItem.id} cartItem={cartItem}/>
            )
        }
        <div className="total">
            <span>TOTAL: ${tota}</span>
        </div>
    </div>
            
            
           { viewForm===true ?
            <CashOnDelivery total={tota} items={cartItems}/>
            :<div><CustomButton style={{
                marginBottom: '20px',
                width: '61%'
            }} type="button" onClick={()=>setView({...view,viewForm:true})}>Cash on Delivery</CustomButton> <PayPalCheckout items={cartItems} price={tota}/> </div>
           }
    </div>
)}
const mapStateToProps = createStructuredSelector({
    cartItems : selectCartItems,
    total: selectCartTotal
})
export default connect(mapStateToProps)(CheckoutPage);